var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isNotAdminSection)?_c('div',{staticClass:"text-h5"},[_vm._v(_vm._s(_vm.$t('AGENT_CATEGORY'))+" "+_vm._s(_vm.getCommercial))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }